import React from "react";
import { useNavigate } from "react-router-dom";
import { useUser } from "../../../DataService/UserContext";
import { DashboardTab } from "../MemberDashboard";
import { AdminIcon } from "../../../Icons/AdminIcon";
import "../MemberDashboard.css";

type Props = {
  activeTab: DashboardTab;
  setActiveTab: (tab: DashboardTab) => void;
  showLibrary: boolean;
};

const DashboardSidebar = ({
  activeTab,
  setActiveTab,
  showLibrary
}: Props) => {
  const { signOut, user } = useUser();
  const navigate = useNavigate();

  const membershipActive = Boolean(
    user?.membershipExpiresAt && new Date(user.membershipExpiresAt) > new Date()
  );

  const items = [
    { id: "overview", label: "Dashboard", icon: AdminIcon.Graph },
    { id: "history", label: "Historik", icon: AdminIcon.Clock },
    ...(showLibrary ? [{ id: "library", label: "Mina kurser", icon: AdminIcon.OpenBook }] : []),
    { id: "seminars", label: "Seminarier", icon: AdminIcon.SimpleCalendar },
    { id: "resources", label: "Material", icon: AdminIcon.Mail },
    { id: "profile", label: "Inställningar", icon: AdminIcon.UserGroup }
  ];

  return (
    <aside className="dashboard-sidebar">
      <div className="dashboard-sidebar-top">
        <div className="dashboard-logo">Sandra Hälsa</div>
        <p className="dashboard-sidebar-copy">Din personliga plats för fortsatt riktning.</p>
        {user && (
          <div className="dashboard-user-chip">
            <span>{membershipActive ? "Aktiv medlem" : "Konto"}</span>
            <strong>{user.email}</strong>
          </div>
        )}
      </div>

      <div className="dashboard-sidebar-support">
        <p className="dashboard-sidebar-support-kicker">Behöver du hjälp?</p>
        <p className="dashboard-sidebar-support-copy">Kontakta oss så hjälper vi dig vidare.</p>
        <button type="button" className="dashboard-sidebar-support-btn" onClick={() => navigate("/contact")}>
          <AdminIcon.Mail width={18} height={18} fill="currentColor" />
          Kontakta support
        </button>
      </div>

      <nav className="dashboard-nav">
        {items.map((item) => (
          <button
            key={item.id}
            type="button"
            className={
              activeTab === item.id
                ? "dashboard-nav-item active"
                : "dashboard-nav-item"
            }
            onClick={() =>
              setActiveTab(item.id as DashboardTab)
            }
          >
            <span className="dashboard-nav-item-content">
              <item.icon width={18} height={18} fill="currentColor" />
              <span>{item.label}</span>
            </span>
          </button>
        ))}
      </nav>

      <button
        type="button"
        className="dashboard-logout"
        onClick={signOut}
      >
        Logga ut
      </button>

    </aside>
  );
};

export default DashboardSidebar;
